import { Grid, Stack, Typography, useTheme } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { StatusInfo } from '../../MediaPlansTable/interfaces';

interface LockedPlanSummaryHeaderProps {
  statusInfo?: StatusInfo;
}

function LockedPlanSummaryHeader({ statusInfo }: LockedPlanSummaryHeaderProps) {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Grid container sx={{ p: '24px 15px 38px 15px' }}>
      <Grid item xs={12}>
        <Stack flexDirection="row" gap={2} alignItems="center">
          <LockIcon sx={{ color: theme.palette.lorealPurple.main }} />
          <Stack>
            <Typography
              variant="body2"
              textTransform="uppercase"
              fontWeight={700}
              color="lorealPurple.main"
            >
              {t('mediaPlanning.planSummary')}
            </Typography>
            <Typography
              variant="body2"
              fontWeight={400}
              color="lorealPurple.main"
            >
              (accepted by {statusInfo?.updatedBy} on{' '}
              {statusInfo?.updatedAt
                ? format(
                    new Date(statusInfo.updatedAt),
                    'dd MMM yyyy, HH:mm:ss'
                  )
                : '-'}
              )
            </Typography>
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
}

export default LockedPlanSummaryHeader;
